module.exports = __webpack_public_path__ + "media/images/city/097-taj-mahal-3cd299571753b5672f9aa2892cf7f029.svg";